;(function() {
  'use strict'

  Factory.$inject = ["glUtils"];
  angular.module('app.core').factory('Project', Factory)

  /* @ngInject */
  function Factory(glUtils) {
    var Events = {
      CREATED: 'project:created',
    }

    var Visibility = {
      EVERYONE: 'EVERYONE',
      PRIVATE: 'PRIVATE',
    }

    function Project(options) {
      _.defaults(this, options, {
        id: null,
        name: null,
        ownerId: null,
        visibility: null,
        privateToGuestIds: [], // only used when visibility = PRIVATE
        canEditVisibilityGuestIds: [],
        surveyCount: 0,
        responseCount: 0,
        trackerCount: 0,
        isArchived: false,
        imageUrl: null,
        createdAt: moment(),
        updatedAt: moment(),
        lastSurveyUpdatedAt: null,
        lastResponseReceivedAt: null,
      })
    }

    Project.prototype.Events = Project.Events = Events
    Project.prototype.Visibility = Project.Visibility = Visibility

    Project.prototype.deserialize = function(data) {
      this.id = data.id
      this.name = data.name
      this.ownerId = data.ownerId
      this.visibility = data.visibility
      this.privateToGuestIds = data.privateToGuestIds
      this.canEditVisibilityGuestIds = data.canEditVisibilityGuestIds
      this.surveyCount = data.surveyCount || 0
      this.responseCount = data.responseCount || 0
      this.trackerCount = data.trackerCount || 0
      this.isArchived = data.isArchived
      this.imageUrl = data.imageUrl
      this.createdAt = moment(data.createdAt)
      this.updatedAt = moment(data.updatedAt)
      this.lastSurveyUpdatedAt = data.lastSurveyUpdatedAt
        ? moment(data.lastSurveyUpdatedAt)
        : null
      this.lastResponseReceivedAt = data.lastResponseReceivedAt
        ? moment(data.lastResponseReceivedAt)
        : null
      return this
    }

    Project.prototype.serialize = function() {
      var data = {}
      data.id = this.id
      data.name = this.name
      data.ownerId = this.ownerId
      data.visibility = this.visibility
      data.privateToGuestIds = this.privateToGuestIds.slice()
      data.canEditVisibilityGuestIds = this.canEditVisibilityGuestIds.slice()
      data.isArchived = this.isArchived
      data.imageUrl = this.imageUrl
      data.createdAt = this.createdAt.toISOString()
      data.updatedAt = this.updatedAt.toISOString()
      data.lastSurveyUpdatedAt = this.lastSurveyUpdatedAt
        ? this.lastSurveyUpdatedAt.toISOString()
        : null
      data.lastResponseReceivedAt = this.lastResponseReceivedAt
        ? this.lastResponseReceivedAt.toISOString()
        : null
      return data
    }

    Project.prototype.isNew = function() {
      return !this.id
    }

    Project.prototype.isPrivate = function() {
      return this.visibility === Visibility.PRIVATE
    }

    Project.prototype.getCountsLabel = function() {
      if (!this.surveyCount && !this.trackerCount && !this.responseCount) {
        return 'no surveys yet'
      }

      var segments = []
      if (this.surveyCount) {
        segments.push(glUtils.countLabel(this.surveyCount, 'survey'))
      }
      if (this.trackerCount) {
        segments.push(glUtils.countLabel(this.trackerCount, 'tracker'))
      }
      segments.push(
        this.responseCount
          ? glUtils.countLabel(this.responseCount, 'response')
          : 'no responses'
      )
      return segments.join(' · ')
    }

    Project.prototype.clone = function() {
      // exact copy only. if you need to modify make a 'duplicate' method
      return new Project().deserialize(this.serialize())
    }

    Project.prototype.replace = function(project) {
      this.deserialize(project.serialize())
    }

    Project.prototype.validate = function() {
      var self = this
      var isValid = true
      self.errors = []

      if (!self.name) {
        self.errors.push('Name is required')
        isValid = false
      }

      if (!self.visibility) {
        self.errors.push('Visibility is required')
        isValid = false
      }

      return isValid
    }

    return Project
  }
})()
